import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery'
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import StaffPage from '../../views/StaffPage/';
const GLOBAL = require('../../Globals');

class EmpAttendance extends Component {

	constructor(props) {
		super(props);
		this.state = {
			id: '',
			acyear: '',
			dept: '',
			attdate: moment(),
			_message: '',
			alertClass: '',
			depart: [],
			posts: [],
			emp: [],
			data: [],
			accyear: [],
			_redirect: false,
			chk: '',
			att: [],
			remark: [],
		}
		this.basestate = this.state;
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onBack = this.onBack.bind(this);
	}

	/** redirect to Attendance view **/
	onBack(e) {

		this.setState({ _redirect: true });
	}

	onRemarkChange(id, depid, e) {

		var index = this.state.att.findIndex(function (obj) {
			return (obj.id == id && obj.dept == depid);
		});

		if (index != -1) {

			this.state.att[index].remarks = e.target.value;

		}
	}

	checkChange(id, depid, e) {

		if (e.target.checked) {
			var index = this.state.att.findIndex(function (obj) {
				return (obj.id == id && obj.dept == depid);
			});

			if (index === -1) {
				this.state.att.push({ "id": id, "dept": depid, "remarks": 0 });
			}

		}
		else {

			for (var i = 0; i < this.state.att.length; i++) {

				if ((this.state.att[i].id == id)) {

					this.state.att.splice(i, 1);
					break;
				}
			}
		}
	}

	/** set value to Attendance datepicker **/
	handleChange(date) {
		this.setState({
			attdate: date
		});
	}

	onChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		this.getemployee();
	}

	onClick() {

		document.getElementById("attform").reset();
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('employee/attendance', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				/* this.setState({
					_message:'Attendance Added Successfully!..',
					alertClass:'alert alert-success',
				}); */
				alert('Attendance Added Successfully!..');
				this.state = this.basestate;
				// document.getElementById("attform").reset();
			}
			else {

				this.setState({
					_message: 'Error!..',
					alertClass: 'alert alert-danger',
				});
			}
		});
	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getacyear();
		this.getdepartment();
	}

	/** get Department **/
	getdepartment() {
		$("#showLoader").show();
		GetData('department/getdepartment').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					depart: responseJson
				});
			}
		});
	}

	/** Get Academic Year **/
	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
			}
		});
	}

	/** get Employee **/
	getemployee() {

		var cs = $("#depart").val();
		$("#showLoader").show();
		GetData('employee/getempbydept/' + cs).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					emp: responseJson
				});
			}
		});
	}

	render() {


		/** disable weekend(sunday) in react-datepicker **/
		var isWeekday = (date) => {

			const day = date.day()
			return day !== 0 && day !== 7
		}

		if (this.state._redirect) {

			return (<Redirect to='/employee/attendanceview' />);
		}

		var dept = this.state.depart;
		var acyear = this.state.accyear;

		if (this.state.acyear != '' && this.state.dept != '') {

			$("#attab").show();

		}
		else {

			$("#attab").hide();
		}

		$('.selectall').click(function () {
			if ($(this).is(':checked')) {
				$('table input').attr('checked', true);
			} else {
				$('table input').attr('checked', false);
			}
		});

		return (
			<div>
				<StaffPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="attform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>Attendance</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
											<option value="">Select</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>
										<span className="pull-right">
											<Button outline color="primary" onClick={this.onBack}>Attendance View</Button>
										</span>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Department <span className="text-danger">*</span></Label>
													<select name="dept" onChange={this.onChange} className="form-control" required id="depart">
														<option value="">Select Department</option>
														<option value="all">All</option>
														{
															dept.map(function (item) {
																return <option value={item.id}>{item.department}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Date <span className="text-danger">*</span></Label>
													<DatePicker selected={this.state.attdate} id="attendancedate" onChange={this.handleChange} className="form-control" dateFormat="DD-MM-YYYY" filterDate={isWeekday} />
												</FormGroup>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
							<Col md="12" id="attab">
								<Card>
									<CardHeader className="card-header-inner">
										<strong>Attendance</strong>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="12">
												<Table responsive bordered id="atttable">
													<thead>
														<tr>
															<th><input type="checkbox" className="selectall" /> Check All</th>
															<th>S.No</th>
															<th>Employee Code</th>
															<th>Employee Name</th>
															<th>Remarks</th>
														</tr>
													</thead>
													<tbody>
														{this.state.emp.map((item, i) =>

															<tr key={item}>
																<td><input type="checkbox" id="chk_all" name="chk_select" onClick={this.checkChange.bind(this, item.id, item.deptid)} /></td>
																<td>{i + 1}</td>
																<td>{item.empcode}</td>
																<td id="subtext">{item.empname}</td>
																<td><input type="text" name="remarks" id={item.id} onChange={this.onRemarkChange.bind(this, item.id, item.deptid)} /></td>
															</tr>
														)}
													</tbody>
												</Table>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<div className="btn-right">
											<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
											<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
										</div>
									</CardFooter>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default EmpAttendance;


// WEBPACK FOOTER //
// ./src/employee/Attendance/EmpAttendance.js